import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-2 border-round bg-white justify-items-center seats-chip" }
const _hoisted_2 = ["textContent"]
const _hoisted_3 = ["textContent"]

import { toRefs } from 'vue';

interface Props {
  text: number;
  title: string;
  textColor: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SeatChip',
  props: {
    text: {},
    title: {},
    textColor: {}
  },
  setup(__props: any) {

const props = __props;

const { text, title, textColor } = toRefs(props);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "text-color-gray text-xs text-center",
      textContent: _toDisplayString(_unref(title))
    }, null, 8, _hoisted_2),
    _createElementVNode("div", {
      class: _normalizeClass(["text-md font-bold text-center pt-1", _unref(textColor)]),
      textContent: _toDisplayString(_unref(text))
    }, null, 10, _hoisted_3)
  ]))
}
}

})